const POI_TYPE = {
    AIRPORT  : 'airport',
    TRAIN    : 'train',
    BUS      : 'bus',
    DEPOT    : 'depot',
    APARTMENT: 'apartment',
    HARBOR   : 'harbor',
    HOTEL    : 'hotel',
}

export type PoiType = typeof POI_TYPE;

export default POI_TYPE;
